import { Link } from 'react-router-dom';

export default function AboutExperience() {
  return (
    <section className="py-16 sm:py-20 lg:py-24 px-4 sm:px-6 lg:px-8 relative bg-black">
      {/* Fondo estrellado sutil */}
      <div className="absolute inset-0">
        {[...Array(30)].map((_, i) => (
          <div
            key={i}
            className="absolute animate-pulse opacity-20"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 3}s`,
              animationDuration: `${3 + Math.random() * 2}s`
            }}
          >
            <div className="w-0.5 h-0.5 rounded-full bg-gold-500"></div>
          </div>
        ))}
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        {/* Título de la sección */}
        <div className="text-center mb-12 sm:mb-16 lg:mb-20">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 sm:mb-6 lg:mb-8 leading-tight font-serif text-gold-500">
            Sobre la Experiencia
          </h2>
          <div className="w-16 sm:w-24 lg:w-32 h-px mx-auto mb-6 sm:mb-8 lg:mb-10 bg-gradient-to-r from-transparent via-gold-500 to-transparent"></div>
          <p className="text-base sm:text-lg lg:text-xl text-gray-200 max-w-4xl mx-auto leading-relaxed px-2 font-sans">
            Vive la Magia de Starlight Christmas. En esta temporada especial te invito a vivir una experiencia única frente a la cámara. He creado dos escenarios llenos de encanto y detalles que harán que tus recuerdos navideños brillen para siempre:
          </p>
        </div>

        {/* Bloques de experiencia */}
        <div className="grid lg:grid-cols-2 gap-8 sm:gap-12 lg:gap-16">
          {/* Bloque 1: Christmas Village Magic */}
          <div className="group">
            <div className="relative overflow-hidden rounded-2xl lg:rounded-3xl mb-6 sm:mb-8 border border-gold-500/20">
              <img 
                src="https://static.readdy.ai/image/d7e77f925f0119a01fe5d8699c3ff655/88f7f8167095df4a28ba0a2544904fcb.png"
                alt="Christmas Village Magic"
                className="w-full h-64 sm:h-80 lg:h-96 object-cover object-top group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 sm:bottom-6 left-4 sm:left-6 right-4 sm:right-6">
                <div className="flex items-center space-x-2 mb-2 text-gold-500">
                  <i className="ri-star-fill text-lg sm:text-xl lg:text-2xl"></i>
                  <span className="text-xs sm:text-sm lg:text-base font-medium tracking-wide font-sans">PUEBLO MÁGICO</span>
                </div>
              </div>
            </div>
            
            <div className="space-y-4 sm:space-y-6 lg:space-y-8">
              <h3 className="text-xl sm:text-2xl lg:text-3xl font-bold leading-tight font-serif text-gold-500">
                🌟 Christmas Village Magic
              </h3>
              <p className="text-sm sm:text-base lg:text-lg leading-relaxed text-gray-200 font-sans">
                Descubre un pueblo encantado lleno de luz y color donde cada rincón cuenta una historia mágica. 
                Nuestro escenario de pueblo navideño te transporta a un cuento de hadas con casitas iluminadas, 
                mercados festivos y una atmósfera que despierta la nostalgia y la alegría de la temporada navideña.
              </p>
              <div className="flex flex-wrap gap-2 sm:gap-3 lg:gap-4">
                {[
                  { text: 'Luces Encantadas', color: 'gold' },
                  { text: 'Ambiente Mágico', color: 'pine' },
                  { text: 'Colores Vibrantes', color: 'cherry' }
                ].map((feature, index) => (
                  <span key={index} className={`px-3 sm:px-4 py-1 sm:py-2 rounded-full text-xs sm:text-sm lg:text-base font-sans ${
                    feature.color === 'gold' ? 'bg-gold-500/20 border border-gold-500/50 text-gold-400' :
                    feature.color === 'pine' ? 'bg-pine-500/20 border border-pine-500/50 text-pine-400' :
                    'bg-cherry-500/20 border border-cherry-500/50 text-cherry-400'
                  }`}>
                    {feature.text}
                  </span>
                ))}
              </div>
            </div>
          </div>

          {/* Bloque 2: The Red Door Christmas */}
          <div className="group">
            <div className="relative overflow-hidden rounded-2xl lg:rounded-3xl mb-6 sm:mb-8 border border-gold-500/20">
              <img 
                src="https://static.readdy.ai/image/d7e77f925f0119a01fe5d8699c3ff655/f3fba75595b444b71263f40e154aba0e.jfif"
                alt="The Red Door Christmas"
                className="w-full h-64 sm:h-80 lg:h-96 object-cover object-top group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 sm:bottom-6 left-4 sm:left-6 right-4 sm:right-6">
                <div className="flex items-center space-x-2 mb-2 text-gold-500">
                  <i className="ri-door-open-fill text-lg sm:text-xl lg:text-2xl"></i>
                  <span className="text-xs sm:text-sm lg:text-base font-medium tracking-wide font-sans">TRADICIÓN</span>
                </div>
              </div>
            </div>
            
            <div className="space-y-4 sm:space-y-6 lg:space-y-8">
              <h3 className="text-xl sm:text-2xl lg:text-3xl font-bold leading-tight font-serif text-gold-500">
                🚪 The Red Door Christmas
              </h3>
              <p className="text-sm sm:text-base lg:text-lg leading-relaxed text-gray-200 font-sans">
                Una entrada acogedora a la tradición navideña más pura. Nuestro icónico escenario de la puerta roja 
                evoca la calidez del hogar y la bienvenida familiar. Cada fotografía captura la esencia de la 
                hospitalidad navideña, creando imágenes llenas de nostalgia y amor familiar.
              </p>
              <div className="flex flex-wrap gap-2 sm:gap-3 lg:gap-4">
                {[
                  { text: 'Calidez Hogareña', color: 'cherry' },
                  { text: 'Tradición Familiar', color: 'gold' },
                  { text: 'Nostalgia Navideña', color: 'pine' }
                ].map((feature, index) => (
                  <span key={index} className={`px-3 sm:px-4 py-1 sm:py-2 rounded-full text-xs sm:text-sm lg:text-base font-sans ${
                    feature.color === 'gold' ? 'bg-gold-500/20 border border-gold-500/50 text-gold-400' :
                    feature.color === 'pine' ? 'bg-pine-500/20 border border-pine-500/50 text-pine-400' :
                    'bg-cherry-500/20 border border-cherry-500/50 text-cherry-400'
                  }`}>
                    {feature.text}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Botón CTA */}
        <div className="text-center mt-12 sm:mt-16 lg:mt-20">
          <Link 
            to="/scenarios"
            onClick={() => window.scrollTo(0, 0)}
            className="inline-block bg-gold-500 hover:bg-gold-600 text-black font-semibold py-3 sm:py-4 lg:py-5 px-6 sm:px-8 lg:px-10 rounded-xl lg:rounded-2xl transition-all duration-300 whitespace-nowrap cursor-pointer text-base sm:text-lg lg:text-xl font-sans" 
          >
            Explora los Escenarios
          </Link>
        </div>

        {/* Estadísticas */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 lg:gap-12 mt-16 sm:mt-20 lg:mt-24">
          {[
            { number: '200+', label: 'Familias Felices', accent: 'gold' },
            { number: '17', label: 'Años de Experiencia', accent: 'cherry' },
            { number: '100%', label: 'Satisfacción', accent: 'pine' },
            { number: '48h', label: 'Entrega Digital', accent: 'gold' }
          ].map((stat, index) => (
            <div key={index} className="text-center group">
              <div className={`text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-2 sm:mb-3 lg:mb-4 font-serif ${
                stat.accent === 'gold' ? 'text-gold-500' :
                stat.accent === 'cherry' ? 'text-cherry-500' :
                'text-pine-500'
              }`}>
                {stat.number}
              </div>
              <div className="text-xs sm:text-sm lg:text-base text-gray-400 group-hover:text-gray-300 transition-colors font-sans">
                {stat.label}
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
